
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/algolia",
      function () {
        return require("private-next-pages/destinations/algolia.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/algolia"])
      });
    }
  